export const SELECT_OPTION_LABEL = 'SELECT';
export const NO_RECORDS_FOUND = 'ΔΕΝ ΒΡΕΘΗΚΑΝ ΕΓΓΡΑΦΕΣ';
export const DELETE_WARNING_MESSAGE = 'ΘΕΛΕΤΕ ΝΑ ΓΙΝΕΙ ΔΙΑΓΡΑΦΗ ?';
export const REQUEST_FILELD_MESSAGE = 'ΣΥΜΠΛΗΡΩΣΤΕ ΤΑ ΥΠΟΧΡΕΩΤΙΚΑ ΠΕΔΙΑ';
export const NEW_RECORD_TITLE = 'ΕΙΣΑΓΩΓΗ - ΔΙΟΡΘΩΣΗ';
